import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators} from "@angular/forms";


@Component({
  selector: "app-economic-aspect",
  templateUrl: "./economic-aspect.component.html",
  styleUrls: ["./economic-aspect.component.scss"],
})
export class EconomicAspectComponent implements OnInit, OnChanges {
  @Input() farmerInfo: FormGroup; // Declare an Input property
  @Input() formTabData: any; // Input property to receive formData from the parent component

  economicForm: FormGroup;
  dateFormat = "dd/MM/yyyy";
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    // Additional logic if needed
  }

  private serializeFormGroup(formGroup: FormGroup): any {
    const serialized = {};
    for (const controlName in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(controlName)) {
        serialized[controlName] = formGroup.get(controlName).value;
      }
    }
    return serialized;
  }

  submitForm() {
    // Handle form submission
    if (!this.economicForm.value.namGhiNhanSanLuong || this.economicForm.value.namGhiNhanSanLuong === '') {
      this.economicForm.get('ngayGhiNhan').setValue(null);
    }
    const formData = {
      economicForm: this.serializeFormGroup(this.economicForm),
    };

    return formData;
  }

  initializeFormGroup() {
    this.economicForm = this.fb.group({
      ngayGhiNhan: [new Date(), Validators.required],
      namGhiNhanSanLuong: [null, Validators.required],
      soCayTruongThanh: [null, Validators.required],
      sanLuongTrai: [null, Validators.required],
      nangSuat: [null, Validators.required],
      giaThuMua: [null, Validators.required],
      thuNhapCacao: [null, Validators.required],
      thuNhapCayTrongKhac: [null, Validators.required],
      hieuQuaKinhTe: [null, Validators.required],
      dienTichCanhTac: [null, Validators.required],
    });
    this.economicForm.get("sanLuongTrai").valueChanges.subscribe(() => {
      this.calculateNangSuat();
    });

    this.economicForm.get("soCayTruongThanh").valueChanges.subscribe(() => {
      this.calculateNangSuat();
    });

    // Subscribe to changes in 'giaThuMua' and 'sanLuongTrai' fields
    this.economicForm.get("giaThuMua").valueChanges.subscribe(() => {
      this.calculateThuNhapCacao();
    });

    this.economicForm.get("sanLuongTrai").valueChanges.subscribe(() => {
      this.calculateThuNhapCacao();
    });

    // Subscribe to changes in 'thuNhapCacao' and 'thuNhapCayTrongKhac' fields
    this.economicForm.get("thuNhapCacao").valueChanges.subscribe(() => {
      this.calculateHieuQuaKinhTe();
    });

    this.economicForm.get("thuNhapCayTrongKhac").valueChanges.subscribe(() => {
      this.calculateHieuQuaKinhTe();
    });

    this.economicForm.get("dienTichCanhTac").valueChanges.subscribe(() => {
      this.calculateHieuQuaKinhTe();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.farmerInfo) {
      this.initializeFormGroup();
    }

    if (changes.formTabData && this.formTabData) {
      this.economicForm.reset();

      try {
        if (this.formTabData.nhanDienThuongHieu) {
          const trimmedJsonString = this.formTabData.khiaCanhKinhTe.trim();
          const economicAspectData = JSON.parse(trimmedJsonString);

          if (economicAspectData) {
            // Check if economicAspectData is defined
            this.setFormValues(this.economicForm, economicAspectData.economicForm);
          }
        }
      } catch (error) {
        console.error("Error parsing JSON data:", error);
        // Handle the error or provide appropriate fallback behavior
      }
    }
  }

  private setFormValues(formGroup: FormGroup, data: any): void {
    for (const controlName in data) {
      if (data.hasOwnProperty(controlName)) {
        const control = formGroup.get(controlName);
        if (control) {
          control.setValue(data[controlName]);
        }
      }
    }
  }

  calculateNangSuat() {
    const sanLuongTrai = this.economicForm.get("sanLuongTrai").value;
    const soCayTruongThanh = this.economicForm.get("soCayTruongThanh").value;
    if (
      sanLuongTrai !== null &&
      soCayTruongThanh !== null &&
      soCayTruongThanh !== 0
    ) {
      const nangSuat = sanLuongTrai / soCayTruongThanh;
      this.economicForm.get("nangSuat").setValue(nangSuat);
    } else {
      this.economicForm.get("nangSuat").setValue(null);
    }
  }
  calculateThuNhapCacao() {
    const giaThuMua = this.economicForm.get("giaThuMua").value;
    const sanLuongTrai = this.economicForm.get("sanLuongTrai").value;
    if (giaThuMua !== null && sanLuongTrai !== null) {
      const thuNhapCacao = giaThuMua * sanLuongTrai;
      this.economicForm.get("thuNhapCacao").setValue(thuNhapCacao);
    } else {
      this.economicForm.get("thuNhapCacao").setValue(null);
    }
  }

  calculateHieuQuaKinhTe() {
    const thuNhapCacao = this.economicForm.get("thuNhapCacao").value;
    const thuNhapCayTrongKhac = this.economicForm.get("thuNhapCayTrongKhac").value;
    const dienTichCanhTac = this.economicForm.get("dienTichCanhTac").value;
    if (
      thuNhapCacao !== null &&
      thuNhapCayTrongKhac !== null &&
      dienTichCanhTac !== null &&
      dienTichCanhTac !== 0
    ) {
      const hieuQuaKinhTe =
        (thuNhapCacao + thuNhapCayTrongKhac) / dienTichCanhTac;
      this.economicForm.get("hieuQuaKinhTe").setValue(hieuQuaKinhTe);
    } else {
      this.economicForm.get("hieuQuaKinhTe").setValue(null);
    }
  }

  getValidationStatus(controlName: string, yourForm: FormGroup): string {
    const control = yourForm.get(controlName);
    return  control.invalid ? 'error' : '';
  }
}
